import { z } from 'zod';
import { assigneeSchema, categorySchema, prioritySchema } from './enums.js';
// Idea inbox / wishlist contract (SPEC §1.4). An unstructured dump; an idea can
// be promoted into a Must/Should/Could list item, carrying its note + link.
const optionalUrl = z
    .string()
    .trim()
    .max(2000)
    .url()
    .optional()
    .or(z.literal('').transform(() => undefined));
export const ideaCreateSchema = z.object({
    body: z.string().trim().min(1, 'Say something').max(2000),
    link: optionalUrl,
    countryId: z.string().nullable().optional(),
});
export const ideaUpdateSchema = z.object({
    body: z.string().trim().min(1).max(2000).optional(),
    link: z.string().trim().max(2000).url().nullable().optional(),
    countryId: z.string().nullable().optional(),
});
export const ideaSchema = z.object({
    id: z.string(),
    tripId: z.string(),
    countryId: z.string().nullable(),
    body: z.string(),
    link: z.string().nullable(),
    promotedToItemId: z.string().nullable(),
    createdAt: z.string(),
});
/** Promote an idea into a list item in a specific country/column. */
export const ideaPromoteSchema = z.object({
    countryId: z.string(),
    priority: prioritySchema,
    category: categorySchema,
    assignee: assigneeSchema.optional(),
});
//# sourceMappingURL=ideas.js.map